module.exports = __webpack_public_path__ + "static/media/facebook-icon.a2ede764.svg";